import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import API from '@/services/api'

export const printPreDesignPDF = async (preDesign, cost) => {
    try {
        const {
            data: { settings },
        } = await API.getSettings()
        const companySetting = settings.find(s => s.name == 'Company')
        let company = companySetting?.generalInfo
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: [250, 300],
        })
        const structuralElements0 = [
            {
                type: 'PANELS',
                fields: ['DIMENSIONS', 'THK', 'DEFLECTION'],
            },
            {
                type: 'MULLIONS',
                fields: ['DIMENSIONS', 'MAX SPAN', 'DEFLECTION'],
            },
        ]
        const structuralElements = [
            { type: 'BRACKET', fields: ['DIMENSIONS', 'THK'] },
            { type: 'FASTENERS', fields: ['SPECIFICATION', 'QTY'] },
            { type: 'ANCHORS', fields: ['SPECIFICATION', 'EMBEDEMENT'] },
        ]
        const structuralElements1 = [
            {
                type: 'OTHERS',
                fields: [
                    'DIMENSIONS',
                    'DEFLECTION',
                    'MAX SPAN',
                    'SPECIFICATION',
                    'THK',
                    'QTY',
                    'EMBEDEMENT',
                ],
            },
        ]
        //Set sections by elements type
        const elementsByType = preDesign.elements.reduce((acc, current) => {
            if (!acc[current.type]) {
                acc[current.type] = []
            }
            acc[current.type].push(current)

            return acc
        }, {})
        // desc options
        let descriptionOptions = {
            styles: {
                halign: 'center',
                valign: 'middle',
                cellPadding: 0,
                margin: 0,
                fontSize: 8,
                lineColor: [0, 0, 0],
                lineWidth: 0.5,
                minCellHeight: 6,
            },
            tableLineColor: [0, 0, 0],
            margin: { top: 35, left: 10 },
            headStyles: {
                fillColor: [211, 211, 211],
                textColor: [0, 0, 0],
            },
        }

        const fontSize = 5
        pdf.setFontSize(fontSize)
        const totalWidth = pdf.internal.pageSize.width - 20

        // set header and footer
        let aspectRatio = 1
        if (company?.logoBase64) {
            aspectRatio = await getAspectRatio(company.logoBase64)
        }
        const header = function(data) {
            if (!company?.logoBase64) {
                return
            }
            // Calculate available space to avoid overlapping with table content
            const marginLeft = data.settings.margin.left
            const firstColumnWidth = totalWidth * 0.3 // First column is 30% of total width
            const tableContentStartX = marginLeft + firstColumnWidth // Where table content (col 1) starts
            const minGap = 5 // Minimum gap between logo and table content
            const availableStartX = marginLeft
            const availableEndX = tableContentStartX - minGap
            const maxAvailableWidth = availableEndX - availableStartX

            // Set maximum dimensions (vertical and horizontal limits)
            const maxImgHeight = 15
            const maxImgWidth = maxAvailableWidth

            // Calculate dimensions based on aspect ratio
            let imgHeight = maxImgHeight
            let imgWidth = imgHeight * aspectRatio

            // Check which constraint is more limiting and scale accordingly
            const widthScale = maxImgWidth / imgWidth
            const heightScale = maxImgHeight / imgHeight
            const scale = Math.min(widthScale, heightScale, 1) // Don't scale up, only down

            // Apply the scale factor
            imgWidth = imgWidth * scale
            imgHeight = imgHeight * scale

            // Center the logo in the first column space
            const firstColumnCenterX = marginLeft + firstColumnWidth / 2
            const imgX = firstColumnCenterX - imgWidth / 2
            const imgY = 15
            pdf.addImage(
                company.logoBase64,
                'PNG',
                imgX,
                imgY,
                imgWidth,
                imgHeight
            )
        }

        const tableDataInfo = [
            [
                { content: '', rowSpan: 3, styles: { minCellHeight: 25 } },
                {
                    content: 'PREDESIGN FORMAT',
                    rowSpan: 3,
                    styles: {
                        fontStyle: 'bold',
                        fontSize: 12,
                    },
                },
                {
                    content: 'CODE',
                    rowSpan: 1,
                    styles: {
                        fontStyle: 'bold',
                    },
                },
                { content: 'F09-PRED-01', rowSpan: 1 },
            ],
            [
                {
                    content: 'DATE',
                    rowSpan: 1,
                    styles: {
                        fontStyle: 'bold',
                    },
                },
                { content: '22/10/2021', rowSpan: 1 },
            ],
            [
                {
                    content: 'VERSION',
                    rowSpan: 1,
                    styles: {
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 1,
                    rowSpan: 1,
                },
            ],
            [
                {
                    content: '',
                    colSpan: 4,
                    styles: { fillColor: [255, 255, 255] },
                }, // Fila vacía para separación
            ],
        ]
        pdf.autoTable({
            body: tableDataInfo,
            startY: 10, // Posición inicial
            theme: 'grid',
            ...descriptionOptions,
            didDrawPage: function(data) {
                header(data)
            },
            columnStyles: {
                0: { cellWidth: totalWidth * 0.3 },
                1: { cellWidth: totalWidth * 0.4 },
                2: { cellWidth: totalWidth * 0.15 },
                3: { cellWidth: 'auto' },
            },
        })
        descriptionOptions.startY = pdf.autoTable.previous.finalY
        descriptionOptions.margin = { top: 0, left: 10 }
        const tableDataInfo2 = [
            [
                {
                    content: 'ENGINEER: ',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        halign: 'left',
                        cellPadding: { left: 2, top: 0, right: 0, bottom: 0 },
                        fontStyle: 'bold',
                    },
                },
                { content: preDesign.engineer, colSpan: 1 },
                {
                    content: 'PROJECT: ',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        halign: 'left',
                        cellPadding: { left: 2, top: 0, right: 0, bottom: 0 },
                        fontStyle: 'bold',
                    },
                },
                { content: cost.quote ? cost.quote.name : '', colSpan: 1 },
            ],
            [
                {
                    content: 'ESTIMATOR: ',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        halign: 'left',
                        cellPadding: { left: 2, top: 0, right: 0, bottom: 0 },
                        fontStyle: 'bold',
                    },
                },
                {
                    content: preDesign.estimator,
                    colSpan: 1,
                },
                {
                    content: 'PRE-DESIGN VERSION:',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        halign: 'left',
                        cellPadding: { left: 2, top: 0, right: 0, bottom: 0 },
                        fontStyle: 'bold',
                    },
                },
                {
                    content: preDesign.versionNumber,
                    colSpan: 1,
                },
            ],
        ]

        pdf.autoTable({
            body: tableDataInfo2,
            theme: 'grid',
            tableLineColor: [0, 0, 0],

            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 0.3 },
                1: { cellWidth: totalWidth * 0.2 },
                2: { cellWidth: totalWidth * 0.2 },
                3: { cellWidth: 'auto' },
            },
        })

        descriptionOptions.startY = pdf.autoTable.previous.finalY
        descriptionOptions.styles.minCellHeight = 5
        const tableDataInfo3 = [
            [
                {
                    content: 'DATE: ',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        halign: 'left',
                        cellPadding: { left: 2, top: 0, right: 0, bottom: 0 },
                        fontStyle: 'bold',
                    },
                },
                {
                    content: preDesign.engineeringDate,
                    colSpan: 1,
                },
                {
                    content: 'LOCATION (CITY/STATE) ',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        halign: 'left',
                        cellPadding: { left: 2, top: 0, right: 0, bottom: 0 },
                        fontStyle: 'bold',
                    },
                }, // Unifica 3 filas
                { content: preDesign.location, colSpan: 1 },
            ],
            [
                {
                    content: 'STRUCTURAL SET',
                    colSpan: 3,
                    styles: {
                        fillColor: [217, 217, 217],
                        cellPadding: { left: 0, top: 0, right: 2, bottom: 0 },
                        halign: 'right',
                        fontStyle: 'bold',
                    },
                },
                {
                    content: preDesign.structuralSet
                        ? preDesign.structuralSet
                        : '',
                    colSpan: 1,
                    styles: { textColor: [255, 0, 0], fontStyle: 'bold' },
                },
            ],
            [
                {
                    content: 'WIND TUNNEL RWDI REPORT',
                    colSpan: 3,
                    styles: {
                        fillColor: [217, 217, 217],
                        cellPadding: { left: 0, top: 0, right: 2, bottom: 0 },
                        halign: 'right',
                        fontStyle: 'bold',
                    },
                },
                {
                    content: preDesign.windTunnelReport
                        ? preDesign.windTunnelReport
                        : '',
                    colSpan: 1,
                    styles: { textColor: [255, 0, 0], fontStyle: 'bold' },
                },
            ],
            [
                {
                    content: 'WIND CODE STANDARDS',
                    colSpan: 3,
                    styles: {
                        fillColor: [217, 217, 217],
                        cellPadding: { left: 0, top: 0, right: 2, bottom: 0 },
                        halign: 'right',
                        fontStyle: 'bold',
                    },
                },
                {
                    content: preDesign.windCodeStd ? preDesign.windCodeStd : '',
                    colSpan: 1,
                    styles: { textColor: [255, 0, 0], fontStyle: 'bold' },
                },
            ],
        ]

        pdf.autoTable({
            body: tableDataInfo3,
            theme: 'grid',
            tableLineColor: [0, 0, 0],

            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 0.1 },
                1: { cellWidth: totalWidth * 0.2 },
                2: { cellWidth: totalWidth * 0.2 },
                3: { cellWidth: 'auto' },
            },
        })

        descriptionOptions.startY = pdf.autoTable.previous.finalY
        let tableDataInfo4 = [
            [
                {
                    content: 'WIND CRITERIA',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 'unit',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 'Value',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 'Comments',
                    colSpan: 1,
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
            ],
        ]
        preDesign.criteriaFields.forEach(criterion =>
            tableDataInfo4.push([
                {
                    content: criterion.criteria,
                    colSpan: 1,
                    styles: {
                        halign: 'left',
                        cellPadding: { left: 2, top: 0, right: 0, bottom: 0 },
                    },
                },
                {
                    content: criterion.unit
                        ? criterion.unit
                        : criterion.value
                        ? 'category'
                        : '',
                    colSpan: 1,
                },
                { content: criterion.value ? criterion.value : '', colSpan: 1 },
                {
                    content: criterion.comments ? criterion.comments : '',
                    colSpan: 1,
                },
            ])
        )
        tableDataInfo4.push([
            {
                content: '',
                colSpan: 4,
                styles: { fillColor: [255, 255, 255] },
            }, // Empty row separation
        ])
        pdf.autoTable({
            body: tableDataInfo4,
            theme: 'grid',
            tableLineColor: [0, 0, 0],

            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 0.3 },
                1: { cellWidth: totalWidth * 0.1 },
                2: { cellWidth: totalWidth * 0.1 },
                3: { cellWidth: 'auto' },
            },
        })

        descriptionOptions.startY = pdf.autoTable.previous.finalY

        let tableDataInfo5_0 = [
            [
                {
                    content: 'STRUCTURAL ELEMENTS',
                    colSpan: 5,
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                }, // Empty row
            ],
        ]

        structuralElements0.forEach(element => {
            tableDataInfo5_0.push([
                {
                    content: element.type,
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements0.find(
                        e => e.type == element.type
                    ).fields[0],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements0.find(
                        e => e.type == element.type
                    ).fields[1],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements0.find(
                        e => e.type == element.type
                    ).fields[2],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 'Comments',
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
            ])
            if (elementsByType[element.type]) {
                elementsByType[element.type].forEach(item => {
                    tableDataInfo5_0.push([
                        {
                            content: item.items.name,
                            colSpan: 1,
                            styles: {
                                halign: 'left',
                                cellPadding: {
                                    left: 2,
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                },
                            },
                        },
                        {
                            content: item.items.dimensions
                                ? item.items.dimensions
                                : item.items.specification
                                ? item.items.specification
                                : '',
                            colSpan: 1,
                            styles: {
                                cellPadding: {
                                    left: 2,
                                    top: 0.5,
                                    right: 2,
                                    bottom: 0.5,
                                },
                            },
                        },
                        {
                            content:
                                item.items.max_span_left ||
                                item.items.max_span_rigth
                                    ? `${
                                          item.items.max_span_left
                                              ? `${item.items.max_span_left}${
                                                    item.items.detailUnit ==
                                                    'Metric'
                                                        ? 'cm'
                                                        : "'"
                                                }`
                                              : ''
                                      } ${
                                          item.items.max_span_rigth
                                              ? `${item.items.max_span_rigth}${
                                                    item.items.detailUnit ==
                                                    'Metric'
                                                        ? 'mm'
                                                        : '"'
                                                }`
                                              : ''
                                      }`
                                    : item.items.THK
                                    ? `${item.items.THK}${
                                          item.items.thkUnit == 'in'
                                              ? '"'
                                              : 'mm'
                                      }`
                                    : item.items.qty
                                    ? `${item.items.qty}${item.items.unit}`
                                    : '',
                            colSpan: 1,
                        },
                        {
                            content: item.items.deflection
                                ? `L/${item.items.deflection}`
                                : '',
                            colSpan: 1,
                        },
                        {
                            content: item.items.comments
                                ? item.items.comments
                                : '',
                            colSpan: 1,
                        },
                    ])
                })
            }
            tableDataInfo5_0.push([
                {
                    content: '',
                    colSpan: 5,
                    styles: { fillColor: [255, 255, 255] },
                }, // Fila vacía para separación
            ])
        })
        pdf.autoTable({
            body: tableDataInfo5_0,
            theme: 'grid', // Centrar texto, negro intenso en todas las líneas
            tableLineColor: [0, 0, 0], // Cambiar color de las líneas separadoras a negro intenso
            // tableLineWidth: 0.5, // Aumentar el grosor de las líneas separadoras

            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 0.15 },
                1: { cellWidth: totalWidth * 0.2 },
                2: { cellWidth: totalWidth * 0.15 },
                3: { cellWidth: totalWidth * 0.15 },
                4: { cellWidth: 'auto' },
            },
        })

        descriptionOptions.startY = pdf.autoTable.previous.finalY

        let tableDataInfo5 = []
        structuralElements.forEach(element => {
            tableDataInfo5.push([
                {
                    content: element.type,
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements.find(
                        e => e.type == element.type
                    ).fields[0],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements.find(
                        e => e.type == element.type
                    ).fields[1],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 'Comments',
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
            ])
            if (elementsByType[element.type]) {
                elementsByType[element.type].forEach(item => {
                    tableDataInfo5.push([
                        {
                            content: item.items.name,
                            colSpan: 1,
                            styles: {
                                halign: 'left',
                                cellPadding: {
                                    left: 2,
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                },
                            },
                        },
                        {
                            content: item.items.dimensions
                                ? item.items.dimensions
                                : item.items.specification
                                ? item.items.specification
                                : '',
                            colSpan: 1,
                            styles: {
                                cellPadding: {
                                    left: 2,
                                    top: 0.5,
                                    right: 2,
                                    bottom: 0.5,
                                },
                            },
                        },
                        {
                            content: item.items.THK
                                ? `${item.items.THK}${
                                      item.items.thkUnit == 'in' ? '"' : 'mm'
                                  }`
                                : item.items.qty
                                ? item.items.qty
                                : item.items.embedment
                                ? `${
                                      item.items.embedment
                                          ? `${item.items.embedment}${
                                                item.items.detailUnit ==
                                                'Metric'
                                                    ? 'mm'
                                                    : '"'
                                            }`
                                          : ''
                                  } `
                                : '',
                            colSpan: 1,
                        },
                        {
                            content: item.items.comments
                                ? item.items.comments
                                : '',
                            colSpan: 1,
                        },
                    ])
                })
            }

            tableDataInfo5.push([
                {
                    content: '',
                    colSpan: 4,
                    styles: { fillColor: [255, 255, 255] },
                },
            ])
            pdf.autoTable({
                body: tableDataInfo5,
                startY: pdf.autoTable.previous.finalY,
                theme: 'grid',
                tableLineColor: [0, 0, 0],

                ...descriptionOptions,
                columnStyles: {
                    0: { cellWidth: totalWidth * 0.15 },
                    1: { cellWidth: totalWidth * 0.2 },
                    2: { cellWidth: totalWidth * 0.15 },
                    3: { cellWidth: 'auto' },
                },
            })
            tableDataInfo5 = []
            descriptionOptions.startY = pdf.autoTable.previous.finalY
        })

        let tableDataInfo6 = []
        structuralElements1.forEach(element => {
            tableDataInfo6.push([
                {
                    content: element.type,
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements1.find(
                        e => e.type == element.type
                    ).fields[0],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements1.find(
                        e => e.type == element.type
                    ).fields[1],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements1.find(
                        e => e.type == element.type
                    ).fields[2],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements1.find(
                        e => e.type == element.type
                    ).fields[3],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements1.find(
                        e => e.type == element.type
                    ).fields[4],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements1.find(
                        e => e.type == element.type
                    ).fields[5],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: structuralElements1.find(
                        e => e.type == element.type
                    ).fields[6],
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 'Comments',
                    styles: {
                        fillColor: [217, 217, 217],
                        fontStyle: 'bold',
                    },
                },
            ])
            if (elementsByType[element.type]) {
                elementsByType[element.type].forEach(item => {
                    tableDataInfo6.push([
                        {
                            content: item.items.name,
                            colSpan: 1,
                            styles: {
                                halign: 'left',
                                cellPadding: {
                                    left: 2,
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                },
                            },
                        },
                        {
                            content: item.items.dimensions
                                ? item.items.dimensions
                                : '',
                            colSpan: 1,
                            styles: {
                                cellPadding: {
                                    left: 2,
                                    top: 0.5,
                                    right: 2,
                                    bottom: 0.5,
                                },
                            },
                        },
                        {
                            content: item.items.deflection
                                ? `L/${item.items.deflection}`
                                : '',
                            colSpan: 1,
                            styles: {
                                cellPadding: {
                                    left: 2,
                                    top: 0.5,
                                    right: 2,
                                    bottom: 0.5,
                                },
                            },
                        },
                        {
                            content:
                                item.items.max_span_left ||
                                item.items.max_span_rigth
                                    ? `${
                                          item.items.max_span_left
                                              ? `${item.items.max_span_left}${
                                                    item.items.detailUnit ==
                                                    'Metric'
                                                        ? 'cm'
                                                        : "'"
                                                }`
                                              : ''
                                      } ${
                                          item.items.max_span_rigth
                                              ? `${item.items.max_span_rigth}${
                                                    item.items.detailUnit ==
                                                    'Metric'
                                                        ? 'mm'
                                                        : '"'
                                                }`
                                              : ''
                                      }`
                                    : '',
                            colSpan: 1,
                            styles: {
                                cellPadding: {
                                    left: 2,
                                    top: 0.5,
                                    right: 2,
                                    bottom: 0.5,
                                },
                            },
                        },
                        {
                            content: item.items.specification
                                ? item.items.specification
                                : '',
                            colSpan: 1,
                            styles: {
                                cellPadding: {
                                    left: 2,
                                    top: 0.5,
                                    right: 2,
                                    bottom: 0.5,
                                },
                            },
                        },
                        {
                            content: item.items.THK
                                ? `${item.items.THK}${
                                      item.items.thkUnit == 'in' ? '"' : 'mm'
                                  }`
                                : '',
                            colSpan: 1,
                            styles: {
                                cellPadding: {
                                    left: 2,
                                    top: 0.5,
                                    right: 2,
                                    bottom: 0.5,
                                },
                            },
                        },
                        {
                            content: item.items.qty ? item.items.qty : '',
                            colSpan: 1,
                            styles: {
                                cellPadding: {
                                    left: 2,
                                    top: 0.5,
                                    right: 2,
                                    bottom: 0.5,
                                },
                            },
                        },
                        {
                            content: item.items.embedment
                                ? `${
                                      item.items.embedment
                                          ? `${item.items.embedment}${
                                                item.items.detailUnit ==
                                                'Metric'
                                                    ? 'mm'
                                                    : '"'
                                            }`
                                          : ''
                                  } `
                                : '',
                            colSpan: 1,
                            styles: {
                                cellPadding: {
                                    left: 2,
                                    top: 0.5,
                                    right: 2,
                                    bottom: 0.5,
                                },
                            },
                        },

                        {
                            content: item.items.comments
                                ? item.items.comments
                                : '',
                            colSpan: 1,
                        },
                    ])
                })
            }

            tableDataInfo6.push([
                {
                    content: '',
                    colSpan: 9,
                    styles: { fillColor: [255, 255, 255] },
                },
            ])
            pdf.autoTable({
                body: tableDataInfo6,
                startY: pdf.autoTable.previous.finalY,
                theme: 'grid',
                tableLineColor: [0, 0, 0],

                ...descriptionOptions,
                columnStyles: {
                    0: { cellWidth: totalWidth * 0.1 },
                    1: { cellWidth: totalWidth * 0.1 },
                    2: { cellWidth: totalWidth * 0.1 },
                    3: { cellWidth: totalWidth * 0.08 },
                    4: { cellWidth: totalWidth * 0.12 },
                    5: { cellWidth: totalWidth * 0.09 },
                    6: { cellWidth: totalWidth * 0.09 },
                    7: { cellWidth: totalWidth * 0.11 },
                    8: { cellWidth: 'auto' },
                },
            })
            tableDataInfo6 = []
            descriptionOptions.startY = pdf.autoTable.previous.finalY
        })

        tableDataInfo6.push([
            {
                content: 'STRUCTURAL ASSUMPTIONS / SITE SPECIAL CONDITIONS',
                colSpan: 9,
                styles: {
                    fillColor: [217, 217, 217],
                    fontStyle: 'bold',
                },
            },
        ])
        // Crear la tabla
        let finalY = 0

        pdf.autoTable({
            body: tableDataInfo6,
            theme: 'grid',
            tableLineColor: [0, 0, 0],

            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 0.4 },
                1: { cellWidth: totalWidth * 0.4 },
                2: { cellWidth: totalWidth * 0.1 },
                3: { cellWidth: 'auto' },
            },

            didDrawPage: data => {
                let yPos = data.cursor.y + 10
                const lineHeight = 4
                const notes = 'Notes: '
                const notas = `${preDesign.notes ? preDesign.notes : ''}`
                pdf.setFontSize(10)
                pdf.setFont('helvetica', 'bold')
                pdf.text(notes, 10, yPos)
                const notesWidth = pdf.getTextWidth(notes)
                pdf.setFont('helvetica', 'normal')
                const wrappedText = pdf.splitTextToSize(
                    notas,
                    totalWidth - notesWidth
                )
                let textlines = wrappedText.length
                const availableHeight = pdf.internal.pageSize.height - yPos - 10
                let linesThatFit = Math.floor(availableHeight / lineHeight)
                let availableRows = wrappedText
                if (textlines <= linesThatFit) {
                    pdf.text(availableRows, 10 + notesWidth, yPos)
                    yPos += availableRows.length * lineHeight
                } else {
                    while (textlines > linesThatFit) {
                        pdf.text(
                            availableRows.slice(0, linesThatFit),
                            10 + notesWidth,
                            yPos
                        )
                        availableRows.splice(0, linesThatFit)
                        pdf.addPage()
                        yPos = 10
                        textlines -= linesThatFit
                        linesThatFit = Math.floor(
                            pdf.internal.pageSize.height -
                                yPos -
                                10 / lineHeight
                        )
                    }
                    pdf.text(availableRows, 10 + notesWidth, yPos)
                    yPos += availableRows.length * lineHeight
                }
                finalY = yPos
            },
        })

        const pageHeight = pdf.internal.pageSize.height - 20
        const pageWidth = pdf.internal.pageSize.width - 10 // Reduced margin for images
        const spacing = 10
        let currentX = 10
        let currentY = finalY
        currentY += spacing

        // Process content in original order if editorHtml is available

        if (preDesign.editorHtml && preDesign.editorHtml.trim()) {
            await processEditorContentInOrder(
                pdf,
                preDesign.editorHtml,
                preDesign.images,
                currentX,
                currentY,
                pageWidth,
                pageHeight,
                spacing
            )
        }

        const pdfDataUri = pdf.output('datauristring')
        const blob = dataURItoBlob(pdfDataUri)
        const blobURL = URL.createObjectURL(blob)
        window.open(blobURL)
        return blob
    } catch (error) {
        console.log(error)
    }
}

const processEditorContentInOrder = async (
    pdf,
    editorHtml,
    images,
    startX,
    startY,
    pageWidth,
    pageHeight,
    spacing
) => {
    let currentX = startX
    let currentY = startY

    // Create a temporary DOM element to parse the HTML
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = editorHtml
    // Process each child element in order
    const processElement = async element => {
        if (element.nodeType === Node.TEXT_NODE) {
            // Process text content
            const text = element.textContent.trim()
            if (text) {
                await addTextToPDF(text)
            }
        } else if (element.nodeType === Node.ELEMENT_NODE) {
            // Handle HTML elements (including formatted text)
            const tagName = element.tagName ? element.tagName.toLowerCase() : ''

            // Check if it's a formatting element that should be processed as text
            if (
                [
                    'div',
                    'span',
                    'strong',
                    'b',
                    'em',
                    'i',
                    'u',
                    'h1',
                    'h2',
                    'h3',
                    'h4',
                    'h5',
                    'h6',
                ].includes(tagName)
            ) {
                // Get all text content from this element and its children
                const text = element.textContent.trim()
                if (text) {
                    await addTextToPDF(text, tagName)
                }
            } else if (tagName === 'ol' || tagName === 'ul') {
                // Handle ordered and unordered lists
                await processListElement(element, tagName)
            } else if (tagName === 'img') {
                // Handle image elements (existing logic)
                await processImageElement(element)
            } else if (tagName === 'p') {
                // Handle paragraph elements - process their children

                for (const child of element.childNodes) {
                    await processElement(child)
                }
            } else {
                // For other elements, process their children

                for (const child of element.childNodes) {
                    await processElement(child)
                }
            }
        }
    }

    const addTextToPDF = async (text, format = 'normal') => {
        // Set font size and style based on format
        pdf.setFontSize(10)

        // Apply formatting based on HTML tag
        switch (format) {
            case 'strong':
            case 'b':
                pdf.setFont('helvetica', 'bold')
                break
            case 'em':
            case 'i':
                pdf.setFont('helvetica', 'italic')
                break
            case 'u':
                pdf.setFont('helvetica', 'normal')
                // Note: jsPDF doesn't support underline natively
                // We'll add a line below the text manually
                break
            case 'h1':
                pdf.setFontSize(16)
                pdf.setFont('helvetica', 'bold')
                break
            case 'h2':
                pdf.setFontSize(14)
                pdf.setFont('helvetica', 'bold')
                break
            case 'h3':
                pdf.setFontSize(12)
                pdf.setFont('helvetica', 'bold')
                break
            case 'h4':
            case 'h5':
            case 'h6':
                pdf.setFontSize(11)
                pdf.setFont('helvetica', 'bold')
                break
            default:
                pdf.setFont('helvetica', 'normal')
        }

        // Calculate available width for text (considering side-by-side layout)
        const availableWidth = pageWidth - currentX + 10 // +10 for margin
        const textWidth = Math.min(availableWidth, pageWidth)
        const textLines = pdf.splitTextToSize(text, textWidth)

        textLines.forEach(line => {
            if (currentY + 5 > pageHeight) {
                pdf.addPage()
                currentY = 10
                currentX = 10
            }
            // Ensure text is within page bounds
            if (currentX > pageWidth) {
                currentX = 10
                currentY += 5
            }

            pdf.text(line, currentX, currentY)

            // Add underline for 'u' format
            if (format === 'u') {
                const textWidth = pdf.getTextWidth(line)
                pdf.line(
                    currentX,
                    currentY + 1,
                    currentX + textWidth,
                    currentY + 1
                )
            }

            currentY += 5
        })

        currentY += spacing
    }

    const processListElement = async (element, listType) => {
        const listItems = element.querySelectorAll('li')

        listItems.forEach((item, index) => {
            const text = item.textContent.trim()
            if (text) {
                // Add list marker
                let marker = ''
                if (listType === 'ol') {
                    marker = `${index + 1}. `
                } else if (listType === 'ul') {
                    marker = '• '
                }

                // Add the list item with marker
                addTextToPDF(marker + text, 'normal')
            }
        })
    }

    const processImageElement = async element => {
        if (element.tagName === 'IMG') {
            // Process image
            const imgName = element.getAttribute('data-name')
            const imgSrc = element.getAttribute('src')
            // Try to find image data even if imgName is missing
            let imageData = null

            if (imgName) {
                // First try to find by name
                imageData = images.find(img => img.name === imgName)
            }

            // If not found by name or no name, try by src
            if (!imageData) {
                imageData = images.find(img => img.src === imgSrc)
            }

            // If still not found, try by base64
            if (!imageData) {
                imageData = images.find(img => img.base64 === imgSrc)
            }

            // If still not found, try to match by base64 content (for pasted images)
            if (!imageData && imgSrc && imgSrc.startsWith('data:image')) {
                imageData = images.find(img => img.base64 === imgSrc)
            }

            if (imgSrc && imageData && (imageData.src || imageData.base64)) {
                // Calculate image dimensions with improved resize logic
                let imgWidth = imageData.width
                let imgHeight = imageData.height

                // Smart resize: maintain proportions while fitting content flow
                // For large images that occupy full editor width, use more of the PDF width
                const maxImageWidth = pageWidth * 0.98 // Use 98% of page width for large images
                const maxImageHeight = pageHeight * 0.5 // Use 50% of page height max
                const minImageSize = 50 // Minimum size to keep images visible

                // Calculate scale factors for both dimensions
                const widthScale = maxImageWidth / imgWidth
                const heightScale = maxImageHeight / imgHeight

                // Use the more restrictive scale to maintain aspect ratio
                const scaleFactor = Math.min(widthScale, heightScale, 1) // Don't upscale

                // Apply scaling
                imgWidth = Math.max(imgWidth * scaleFactor, minImageSize)
                imgHeight = Math.max(imgHeight * scaleFactor, minImageSize)

                // Final check: ensure image doesn't exceed page bounds
                if (imgWidth > pageWidth) {
                    const finalScale = pageWidth / imgWidth
                    imgWidth *= finalScale
                    imgHeight *= finalScale
                }

                if (imgHeight > pageHeight * 0.6) {
                    // Max 60% of page height for large images
                    const finalScale = (pageHeight * 0.6) / imgHeight
                    imgWidth *= finalScale
                    imgHeight *= finalScale
                }

                // Check if image fits on current line
                if (currentX + imgWidth <= pageWidth) {
                    // Move to next line if not at start position
                    if (currentX !== 10) {
                        currentX = 10
                        currentY += spacing // Add spacing before image
                    }
                    if (currentY + imgHeight > pageHeight) {
                        pdf.addPage()
                        currentY = 10
                        currentX = 10
                    }
                    pdf.addImage(
                        imageData.src || imageData.base64,
                        'JPEG',
                        currentX,
                        currentY,
                        imgWidth,
                        imgHeight
                    )

                    // Smart positioning: check if next element is text and can fit beside image
                    const nextElement = element.nextSibling
                    const availableWidthForText =
                        pageWidth - (currentX + imgWidth + 10) // 10px margin (less conservative)
                    const canFitBeside =
                        nextElement &&
                        nextElement.nodeType === Node.TEXT_NODE &&
                        nextElement.textContent.trim() &&
                        availableWidthForText > 30 // Minimum 30px for text (much more flexible)

                    if (canFitBeside) {
                        // Position for side-by-side layout
                        currentX += imgWidth + 10 // Move X to right of image with small margin
                        // Keep currentY the same for side-by-side
                    } else {
                        // Traditional layout: text below image
                        currentY += imgHeight + spacing // Add spacing after image
                        currentX = 10 // Reset X to beginning of line for next element
                    }
                } else {
                    // Move to next line
                    currentX = 10
                    if (currentY + imgHeight > pageHeight) {
                        pdf.addPage()
                        currentY = 10
                    }
                    pdf.addImage(
                        imageData.src || imageData.base64,
                        'JPEG',
                        currentX,
                        currentY,
                        imgWidth,
                        imgHeight
                    )

                    // Smart positioning: check if next element is text and can fit beside image
                    const nextElement = element.nextSibling
                    const availableWidthForText =
                        pageWidth - (currentX + imgWidth + 10) // 10px margin (less conservative)
                    const canFitBeside =
                        nextElement &&
                        nextElement.nodeType === Node.TEXT_NODE &&
                        nextElement.textContent.trim() &&
                        availableWidthForText > 30 // Minimum 30px for text (much more flexible)

                    if (canFitBeside) {
                        // Position for side-by-side layout
                        currentX += imgWidth + 10 // Move X to right of image with small margin
                        // Keep currentY the same for side-by-side
                    } else {
                        // Traditional layout: text below image
                        currentY += imgHeight + spacing // Add spacing after image
                        currentX = 10 // Reset X to beginning of line for next element
                    }
                }

                // Note: spacing already added above, no need to add again
                currentX += spacing
            }
        }
    }

    // Process all child elements
    for (let i = 0; i < tempDiv.childNodes.length; i++) {
        const child = tempDiv.childNodes[i]
        try {
            await processElement(child)
        } catch (error) {
            console.error(error)
        }
    }
}

const getAspectRatio = async file => {
    return new Promise(function(resolved) {
        var i = new Image()
        i.onload = function() {
            resolved(i.width / i.height)
        }
        i.src = file
    })
}

const dataURItoBlob = dataURI => {
    const byteString = Uint8Array.from(atob(dataURI.split(',')[1]), c =>
        c.charCodeAt(0)
    )
    const blobType = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
    return new Blob([byteString], { type: blobType })
}
